import {
	FormItem,
	ReorderableList,
	Select,
	SelectOption,
	TextInput,
	ValidationError
} from "client/Components";
import { IInputAttachable, IValueInputAttachable } from "client/Forms/attachable";
import { useCallback } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { UpdateMagisterTabModel } from "client/Api/Workspace/workspace";
import { MagisterResourceKind } from "client/Api/Workspace/LiveInformation/Magister/magisterLiveInformation";

type EditMagisterTabItemProps = {
	attachable: IValueInputAttachable<UpdateMagisterTabModel>;
	onRemove: () => void;
};

export const EditMagisterTabItem = (props: EditMagisterTabItemProps) => {
	const { attachable, onRemove } = props;

	const nameAttachable: IInputAttachable<string> = attachable.for("name");

	const resourceKindChangeHandler = useCallback(
		(newValue: MagisterResourceKind | undefined): void => {
			if (
				newValue !== attachable.value
					.resourceKind
			) {
				const onChange: (newValue: string) => void = nameAttachable.attachToTextInput()
					.onChange;

				const nameValue: string = tabKindOptions
					.find((option) => option.value === newValue)
					?.text ?? "";

				onChange(nameValue);
			}
		},
		[
			nameAttachable,
			attachable.value
				.resourceKind
		]
	);

	return (
		<ReorderableList.PanelItem
			{...attachable.attachToReorderableListPanelItem(true)}
			header={
				<Select
					{...attachable
						.for("resourceKind")
						.attachToSelect()
						.withOnChange(resourceKindChangeHandler)}
					options={tabKindOptions}
					placeholder={localize("_PleaseSelect")}
					menuTitle={localize("_Source")}
				/>
			}
			onRemove={onRemove}
		>
			<ValidationError
				{...attachable.for("resourceKind")
					.attachToValidationError()}
			/>
			<FormItem
				label={localize("_TabName")}
			>
				<TextInput {...nameAttachable.attachToTextInput()} />
				<ValidationError {...nameAttachable.attachToValidationError()} />
			</FormItem>
		</ReorderableList.PanelItem>
	);
};

EditMagisterTabItem.displayName = "EditMagisterTabItem";

const tabKindOptions: readonly SelectOption<MagisterResourceKind>[] = [
	{ text: localize("_MyGrades"), value: MagisterResourceKind.Grades },
	{ text: localize("_MySchedule"), value: MagisterResourceKind.Schedule }
];
